import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Helper to check if credentials are valid
export const isSupabaseConfigured = () => {
  return (
    supabaseUrl && 
    supabaseUrl.startsWith('https://') && 
    !supabaseUrl.includes('your-project') &&
    supabaseAnonKey && 
    supabaseAnonKey !== 'your-anon-key'
  );
};

// Use a fallback to prevent the app from crashing on load
const safeUrl = isSupabaseConfigured() ? supabaseUrl : 'https://placeholder-project.supabase.co';
const safeKey = isSupabaseConfigured() ? supabaseAnonKey : 'placeholder-key';

export const supabase = createClient(safeUrl, safeKey);